import { Doc } from '@/docs/Doc';
import { cn } from '@/shared/react';
import { useRuntimeEnv } from '@/shared/runtimeEnv';
import { useWhyChooseUsList } from '../landing/useWhyChooseUsList';
import { CoinTradeWidget } from './coin/fields/CoinTradeWidget';

const MarketPageBuyHeader = () => {
  const list = useWhyChooseUsList();
  const { isStandalone } = useRuntimeEnv();

  return (
    <section className={cn('bg-background-disabled/40 desktop:pt-16 pt-8')}>
      <div className="max-w-desktop mx-auto px-3 pb-4 grid desktop:grid-cols-3 grid-cols-1 gap-widget">
        <div className="col-span-2 flex flex-col gap-3 desktop:gap-12">
          <Doc name="buy-and-sell" />
          <div className="flex desktop:gap-8 gap-4 items-stretch justify-between desktop:max-w-[70%]">
            {list.map((item) => (
              <div
                key={item.key}
                className="bg-background-brand/5 p-1 rounded-5xl overflow-hidden"
              >
                <img
                  src={item.background}
                  alt={item.key}
                  width="100%"
                  className="w-full h-auto"
                />
                <h3 className="text-md desktop:text-xl text-start pt-4 pb-2 px-widget font-medium">
                  {item.title}
                </h3>
                <p className="text-sm desktop:text-md px-widget pb-5 text-start">
                  {item.description}
                </p>
              </div>
            ))}
          </div>
        </div>
        {/* temporary change for standalone app */}
        {!isStandalone && (
          <div className="desktop:col-span-1 col-span-2 rounded-lg">
            <CoinTradeWidget className="bg-background-primary" />
          </div>
        )}
      </div>
    </section>
  );
};

export default MarketPageBuyHeader;
